import type { Calidad } from './types';

/**
 * Convierte la `nota` técnica de una fila en señales de calidad legibles.
 *
 *   "OCR: Maute (kg)"                                   → ocr
 *   "OCR: Vacaenpie(kg); coma corregida 15->1.5"        → ocr + corregido, aviso "Coma corregida: 15 → 1,5"
 *   "[SIMULADO] histórico de demostración"              → simulado, aviso "Histórico de demostración"
 *   "Fedeagro IPAF #377 — AGUACATE"                     → aviso con el texto (no es ningún problema de calidad)
 *
 * El texto crudo que leyó el OCR (lo que sigue a "OCR:" hasta el primer ";") NO es un aviso para la
 * persona: es ruido técnico ("Vacaenpie(kg)"), así que se descarta.
 */
const PREFIJO_SIMULADO = /^\[simulado\]\s*[:\-–—]?\s*/i;
const PREFIJO_OCR = /^ocr\b\s*:?\s*/i;
const COMA_CORREGIDA = /^coma corregida\s+(-?[\d.,]+)\s*(?:->|=>|→|a)\s*(-?[\d.,]+)\.?$/i;

const capitalizar = (texto: string): string => texto.charAt(0).toUpperCase() + texto.slice(1);
/** El valor corregido llega con punto decimal ("1.5"); en pantalla va con coma. */
const aComa = (valor: string): string => valor.replace('.', ',');

export function calidadDeNota(nota: string | null | undefined): Calidad {
  const calidad: Calidad = { ocr: false, corregido: false, simulado: false, avisos: [] };
  let resto = nota?.trim() ?? '';
  if (PREFIJO_SIMULADO.test(resto)) {
    calidad.simulado = true;
    resto = resto.replace(PREFIJO_SIMULADO, '');
  }
  if (PREFIJO_OCR.test(resto)) {
    calidad.ocr = true;
    resto = resto.replace(PREFIJO_OCR, '');
  }
  const segmentos = resto
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean);
  segmentos.forEach((segmento, indice) => {
    const correccion = COMA_CORREGIDA.exec(segmento);
    if (correccion) {
      calidad.corregido = true;
      calidad.avisos.push(`Coma corregida: ${correccion[1]} → ${aComa(correccion[2] ?? '')}`);
    } else if (/coma corregida/i.test(segmento)) {
      calidad.corregido = true;
      calidad.avisos.push(capitalizar(segmento));
    } else if (!(calidad.ocr && indice === 0)) {
      calidad.avisos.push(capitalizar(segmento));
    }
  });
  return calidad;
}
